<template>
    <div class="uplimit-step-view">
        <div class="row align-items-center mb-2 px-2">
            <div class="d-flex flex-wrap align-items-center w-100">
                <div class="control-item">
                    <b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" v-model="date1" today-button close-button locale="zh"></b-form-datepicker>
                </div>
                <div class="control-item">
                    <b-form-select v-model="show_top_n" :options="topNOptions" size="sm"></b-form-select>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_market" v-model.number="status_market" value="1" unchecked-value="0" size="sm" @click="click_show_market">行情</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_count" v-model.number="show_count" value="1" unchecked-value="0" size="sm">个数</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_time" v-model.number="show_time" value="1" unchecked-value="0" size="sm">时间</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_score" v-model.number="show_score" value="1" unchecked-value="0" size="sm">分数</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_amount" v-model.number="show_amount" value="1" unchecked-value="0" size="sm">成交额</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_market_value" v-model.number="show_market_value" value="1" unchecked-value="0" size="sm">市值</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_sealed_order" v-model.number="show_sealed_order" value="1" unchecked-value="0" size="sm">封单</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_circulating_value" v-model.number="show_circulating_value" value="1" unchecked-value="0" size="sm">流通市值</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_highlight_multi" v-model.number="highlight_multi" value="1" unchecked-value="0" size="sm">标多概念</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_min_chart" v-model.number="show_min_chart" value="1" unchecked-value="0" size="sm">分时</b-form-checkbox>
                </div>
                <div class="control-item ml-auto">
                    <b-button size="sm" variant="primary" @click="refresh_page">刷新</b-button>
                </div>
            </div>
        </div>

        <!-- 梯队内容容器：支持横向滚动 -->
        <div class="ladder-scroll-wrapper">
            <div class="ladder-grid" :style="{ minWidth: (plates.length * 110 + 90) + 'px' }">
                <div class="row no-gutters flex-nowrap">
                    <div class="ladder-header-col border alert-primary d-flex align-items-center justify-content-center text-center">梯队 / 板块</div>
                    <div class="col alert-danger border py-1 px-1 text-center d-flex flex-column justify-content-center" v-bind:key="plate.index" v-for="plate in plates">
                        <div class="text-truncate">
                            <span class="plate-name-badge" @click="openPlateModal(plate)">{{plate['name']}}</span>
                            <span class="small-count ml-1" v-if="show_count">{{ getPlateNonBrokenStockCount(plate['code']) }}</span>
                        </div>
                        <div v-if="show_score" class="mt-0">
                            <span class="badge-score">{{ plate['score'] }}</span>
                        </div>
                    </div>
                </div>

                <div class="row no-gutters flex-nowrap" v-bind:key="ban" v-for="ban in bans">
                    <div v-if="ban==0" class="ladder-header-col border alert-danger d-flex align-items-center justify-content-center">炸 板</div>
                    <div v-else class="ladder-header-col border alert-danger d-flex flex-column align-items-center justify-content-center py-1">
                        <div class="ban-row">
                            <span class="ban-number">{{ban}}板</span>
                            <span v-if="show_count && ban_info[ban]" class="small-count ml-1">{{ban_info[ban].count}}个</span>
                        </div>
                        <div v-if="promotion_rates[ban]" class="badge badge-success-outline mt-0">{{promotion_rates[ban]}}</div>
                    </div>
                    
                    <div class="col border ladder-content-cell" v-bind:key="plate['code']" v-for="plate in plates">
                        <div class="stock_item_block" :class="{ 'top-stock-highlight': (highlight_multi===1 && isTopStock(ban, stock['stock_code'])), 'second-stock-highlight': (highlight_multi===1 && isSecondStock(ban, stock['stock_code'])) }" v-bind:key="stock['stock_code']+'_'+plate['code']+'_'+ban+'_'+(stock['up_limit_time']||'')+'_'+idx" v-for="(stock, idx) in stocks_plate[ban][plate['code']]">
                            <StockMarketItem 
                                @show_sidebar="show_sidebar" 
                                :is_show_market=status_market 
                                :stock_info="stock" 
                                :market="stock['market']" 
                                :show_time="show_time" 
                                :show_amount="show_amount"
                                :show_market_value="show_market_value"
                                :show_circulating_value="show_circulating_value"
                                :show_sealed_order="show_sealed_order"
                            ></StockMarketItem>
                            <div v-if="show_min_chart===1 && ((Number(ban)>=2) || (show_min_chart_ban1===1 && Number(ban)===1))" class="uplimit-min-chart-placeholder border-bottom" :data-stock-code="stock['stock_code']">
                                <StockMiniTrend 
                                    v-if="visibleStocks[stock['stock_code']]" 
                                    :key="stock['stock_code']+'_'+(status_market===1?'real':date1)+'_'+plate['code']+'_'+ban+'_'+min_chart_refresh_seq"
                                    :symbol_code="stock['stock_code']" 
                                    :selected_date="status_market===1 ? '' : date1"
                                    :refresh_seq="min_chart_refresh_seq"
                                    chart_heigh="50px"
                                />
                                <div v-else class="mini-chart-loading">
                                    <span>载入中...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <PlateKlineModal 
            v-if="showPlateModal"
            :visible="showPlateModal" 
            :plateCode="selectedPlateCode" 
            :plateName="selectedPlateName" 
            :selectedDate="date1" 
            @close="closePlateModal"/>
        
        <div class="row align-items-center" style="margin-top:8px;">
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                    id="checkbox_show_min_chart_ban1"
                    :key="checkbox_ban1_key"
                    v-model.number="show_min_chart_ban1"
                    name="checkbox_show_min_chart_ban1"
                    value="1"
                    unchecked-value="0"
                    size="sm"
                >首板分时</b-form-checkbox>
            </div>
        </div>
        <b-modal v-model="showLoginPrompt" title="需要登录" hide-footer @hidden="onPromptHidden">
            <div>开启首板分时需要登录账号</div>
            <div class="mt-2">
                <b-button size="sm" variant="primary" @click="goLoginFromPrompt">登录</b-button>
                <b-button size="sm" class="ml-2" variant="secondary" @click="onCancelPrompt">取消</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import StockMarketItem from 'components/stock/StockMarketItem.vue'
    import { request_zzquant } from "network/request.js"

    export default {
        props: {},
        components: {
            StockMarketItem,
            PlateKlineModal: () => import('components/plate/PlateKlineModal.vue'),
            StockMiniTrend: () => import('components/stock/StockMiniTrend.vue')
        },
        mounted() {
            const savedMarketStatus = localStorage.getItem('uplimit_status_market');
            const savedShowCount = localStorage.getItem('uplimit_show_count');
            const savedShowTime = localStorage.getItem('uplimit_show_time');
            const savedShowTopN = localStorage.getItem('uplimit_show_top_n');
            const savedShowScore = localStorage.getItem('uplimit_show_score');
            const savedShowAmount = localStorage.getItem('uplimit_show_amount');
            const savedShowMarketValue = localStorage.getItem('uplimit_show_market_value');
            const savedShowCirculatingValue = localStorage.getItem('uplimit_show_circulating_value');
            const savedShowSealedOrder = localStorage.getItem('uplimit_show_sealed_order');
            const savedHighlightMulti = localStorage.getItem('uplimit_highlight_multi');
            const savedShowMinChart = localStorage.getItem('uplimit_show_min_chart');
            const savedShowMinChartBan1 = localStorage.getItem('uplimit_show_min_chart_ban1');
            
            if (savedMarketStatus !== null) this.status_market = parseInt(savedMarketStatus);
            if (savedShowCount !== null) this.show_count = parseInt(savedShowCount);
            if (savedShowTime !== null) this.show_time = parseInt(savedShowTime);
            if (savedShowTopN !== null) this.show_top_n = parseInt(savedShowTopN);
            if (savedShowScore !== null) this.show_score = parseInt(savedShowScore);
            if (savedShowAmount !== null) this.show_amount = parseInt(savedShowAmount);
            if (savedShowMarketValue !== null) this.show_market_value = parseInt(savedShowMarketValue);
            if (savedShowCirculatingValue !== null) this.show_circulating_value = parseInt(savedShowCirculatingValue);
            if (savedShowSealedOrder !== null) this.show_sealed_order = parseInt(savedShowSealedOrder);
            if (savedHighlightMulti !== null) this.highlight_multi = parseInt(savedHighlightMulti);
            if (savedShowMinChart !== null) this.show_min_chart = parseInt(savedShowMinChart);
            if (savedShowMinChartBan1 !== null) this.show_min_chart_ban1 = parseInt(savedShowMinChartBan1);
            
            request_zzquant({url:'/v3/market/trade/days'}).then(res => {
                let days = res && res.data && res.data.data ? res.data.data : [];
                if (days.length > 0) {
                    this.all_trading_days = days;
                    this.date1 = days[days.length-1];
                } else {
                    const now = new Date();
                    const year = now.getFullYear();
                    const month = String(now.getMonth() + 1).padStart(2, '0');
                    const day = String(now.getDate()).padStart(2, '0');
                    this.date1 = `${year}-${month}-${day}`;
                }
            }).catch(() => {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                this.date1 = `${year}-${month}-${day}`;
            });
            if(this.show_min_chart) {
                this.$nextTick(this.initObserver)
            }
        },
        beforeDestroy(){ 
            if(this.observer){ this.observer.disconnect() }
        },
        watch: {
            date1(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.update_info(newVal);
                }
            },
            status_market(newVal) {
                localStorage.setItem('uplimit_status_market', newVal);
                this.update_info(this.date1);
            },
            show_count(newVal) {
                localStorage.setItem('uplimit_show_count', newVal);
            },
            show_time(newVal) {
                localStorage.setItem('uplimit_show_time', newVal);
            },
            show_top_n(newVal) {
                localStorage.setItem('uplimit_show_top_n', newVal);
                this.update_info(this.date1);
            },
            show_score(newVal) {
                localStorage.setItem('uplimit_show_score', newVal);
            },
            show_amount(newVal) {
                localStorage.setItem('uplimit_show_amount', newVal);
            },
            show_market_value(newVal) {
                localStorage.setItem('uplimit_show_market_value', newVal);
            },
            show_circulating_value(newVal) {
                localStorage.setItem('uplimit_show_circulating_value', newVal);
            },
            show_sealed_order(newVal) {
                localStorage.setItem('uplimit_show_sealed_order', newVal);
            },
            highlight_multi(newVal) {
                localStorage.setItem('uplimit_highlight_multi', newVal);
            },
            show_min_chart(newVal) {
                localStorage.setItem('uplimit_show_min_chart', newVal);
                if(newVal) {
                    this.$nextTick(this.initObserver)
                } else {
                    if(this.observer) {
                        this.observer.disconnect()
                        this.observer = null
                    }
                    this.visibleStocks = {}
                }
            },
            show_min_chart_ban1(newVal) {
                localStorage.setItem('uplimit_show_min_chart_ban1', newVal);
                if(newVal && this.show_min_chart) {
                    this.$nextTick(this.observeStockRows)
                }
                if (parseInt(newVal) === 1) {
                    let token = ''
                    try { token = localStorage.getItem('token') || '' } catch(e) { token = '' }
                    if (!token) {
                        this.show_min_chart_ban1 = 0
                        localStorage.setItem('uplimit_show_min_chart_ban1', 0)
                        this.loginRedirect = (this.$route && this.$route.fullPath) || (window.location && window.location.pathname) || '/'
                        this.$nextTick(() => { this.showLoginPrompt = true })
                        this.checkbox_ban1_key++
                    }
                }
            }
        },
        data() {
            return {
                reqId: 0,
                status_market: 0,
                show_count: 1,
                show_time: 1,
                show_score: 0,
                show_amount: 0,
                show_market_value: 0,
                show_circulating_value: 0,
                show_sealed_order: 0,
                highlight_multi: 0,
                show_min_chart: 0,
                show_min_chart_ban1: 0,
                checkbox_ban1_key: 0,
                showLoginPrompt: false,
                loginRedirect: '',
                show_top_n: 12,
                topNOptions: [
                    { value: 5, text: '显示板块: 5个' },
                    { value: 8, text: '显示板块: 8个' },
                    { value: 10, text: '显示板块: 10个' },
                    { value: 12, text: '显示板块: 12个' },
                    { value: 15, text: '显示板块: 15个' },
                    { value: 20, text: '显示板块: 20个' }
                ],
                min_chart_refresh_seq: 0,
                date1: '',
                bans: [5, 4, 3, "炸"],
                ban_info: {},
                plates: [{"name": "loading...", "code": "8001", "score":0}],
                stocks_plate: {
                    "5": { "8001": [] },
                    "4": { "8001": [] },
                    "3": { "8001": [] },
                    "炸": { "8001": [] },
                },
                topStocksByBan: {},
                showPlateModal:false,
                selectedPlateCode:'',
                selectedPlateName:'',
                all_trading_days: [],
                promotion_rates: {},
                visibleStocks: {},
                observer: null,
            };
        },
        methods: {
            initObserver() {
                if (this.observer) this.observer.disconnect();
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const stockCode = entry.target.dataset.stockCode;
                            if (stockCode && !this.visibleStocks[stockCode]) {
                                this.$set(this.visibleStocks, stockCode, true);
                                this.observer.unobserve(entry.target);
                            }
                        }
                    });
                }, { rootMargin: '100px' });
                this.observeStockRows();
            },
            observeStockRows() {
                if (!this.observer) return;
                const elements = this.$el.querySelectorAll('.uplimit-min-chart-placeholder');
                elements.forEach(el => {
                    if (!this.visibleStocks[el.dataset.stockCode]) this.observer.observe(el);
                });
            },
            refresh_page() {
                this.update_info(this.date1);
                this.min_chart_refresh_seq++;
            },
            checkIsPreviousTradingDay(dateStr) {
                if (!this.all_trading_days || this.all_trading_days.length === 0) return false;
                const now = new Date();
                const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
                let prevDay = null;
                for (let i = this.all_trading_days.length - 1; i >= 0; i--) {
                    if (this.all_trading_days[i] < today) {
                        prevDay = this.all_trading_days[i];
                        break;
                    }
                }
                return dateStr === prevDay;
            },
            isLimitUp(stock) {
                if (!stock || !stock.market) return false;
                const rate = stock.market.px_change_rate;
                const code = String(stock.stock_code || '');
                const name = String(stock.stock_name || '');
                if (rate === undefined || rate === null) return false;
                if (code.startsWith('30') || code.startsWith('68')) return rate >= 19.5;
                if (code.startsWith('8')) return rate >= 29.5;
                if (name.includes('ST')) return rate >= 4.5;
                return rate >= 9.5;
            },
            calculatePromotionRates() {
                this.promotion_rates = {};
                if (!this.checkIsPreviousTradingDay(this.date1)) return;
                if (this.status_market !== 1) return;
                for (const ban in this.stocks_plate) {
                    if (ban == 0 || ban === '炸') continue;
                    const distinctStocks = new Set();
                    let limitUpCount = 0;
                    for (const plateCode in this.stocks_plate[ban]) {
                        const stocks = this.stocks_plate[ban][plateCode];
                        if (stocks && stocks.length) {
                            stocks.forEach(stock => {
                                if (!distinctStocks.has(stock.stock_code)) {
                                    distinctStocks.add(stock.stock_code);
                                    if (this.isLimitUp(stock)) limitUpCount++;
                                }
                            });
                        }
                    }
                    const total = distinctStocks.size;
                    if (total > 0) {
                        const rate = Math.round((limitUpCount / total) * 100) + '%';
                        this.$set(this.promotion_rates, ban, rate);
                    }
                }
            },
            show_sidebar(stock_info){
                if (!stock_info['date1']) stock_info['date1'] = this.date1;
                this.$emit('show_sidebar',stock_info)
            },
            click_show_market(){ this.update_info(this.date1); },
            goLoginFromPrompt(){
                const redirect = this.loginRedirect || (this.$route && this.$route.fullPath) || '/'
                this.$router.push({ path: '/login', query: { redirect } })
                this.showLoginPrompt = false
            },
            dateDisabled(ymd, date) {
                const weekday = date.getDay();
                if (weekday === 0 || weekday === 6) return true;
                if (date.getTime() >= new Date().getTime()) return true;
                return false
            },
            real_time_info_stock(real_time_stocks,stock) {
                if(!real_time_stocks) return false;
                var fields = real_time_stocks['fields']
                var values = real_time_stocks['values']
                var idx = fields.indexOf(stock)
                if(idx > -1) return values[idx]
                return false
            },
            getPlateNonBrokenStockCount(plateCode) {
                let count = 0;
                for (let ban in this.stocks_plate) {
                    if (ban != 0 && this.stocks_plate[ban][plateCode]) count += this.stocks_plate[ban][plateCode].length;
                }
                return count;
            },
            update_table_info(res,res2){
                let data = res && res.data && res.data.data;
                if (!data || !Array.isArray(data['plate'])) {
                    this.plates = [];
                    this.bans = [];
                    this.stocks_plate = {};
                    this.ban_info = {};
                    return;
                }
                let plates = data['plate'];
                let plate_stocks = data['plate_stocks'] || {};
                let ban_info = data['ban_info'] || {};
                this.ban_info = ban_info;
                let plate_arr = [];
                plates.forEach((item) => {
                    plate_arr.push({ "name": item[0], "code": item[1], "score": item[2] })
                });
                this.plates = plate_arr;
                let ban_arr = [];
                for (let i = data.max_count; i > -1; i--) ban_arr.push(i);
                this.bans = ban_arr;
                let stocks_plate_dict = {};
                for (let idx in ban_arr) {
                    let ban = ban_arr[idx]
                    stocks_plate_dict[ban] = {}
                    plates.forEach((item) => {
                        let plate_code = item[1]
                        stocks_plate_dict[ban][plate_code] = []
                        let stocks_on_plate = plate_stocks[plate_code] || []
                        stocks_on_plate.forEach((item2) => {
                            if (item2['up_limit_keep_times'] == ban) {
                                if(this.status_market==1 && res2){
                                    let market = this.real_time_info_stock(res2['data'] && res2['data']['data'],item2['stock_code']);
                                    item2['market']  = market;
                                }else{
                                    item2['market']  = {"px_change_rate":0,"open_px_rate":0}
                                }
                                stocks_plate_dict[ban][plate_code].push(item2)
                            }
                        })
                        stocks_plate_dict[ban][plate_code].sort((a, b) => {
                            const t1 = a.up_limit_time || '';
                            const t2 = b.up_limit_time || '';
                            return t1.localeCompare(t2);
                        });
                    });
                }
                this.stocks_plate = stocks_plate_dict;
                if(this.show_min_chart) this.$nextTick(this.observeStockRows);
                this.computeTopStocksByBan();
                this.calculatePromotionRates();
            },
            computeTopStocksByBan(){
                const result = {};
                for(const ban in this.stocks_plate){
                    if(String(ban)==='0'){ result[ban] = { tops1:{}, tops2:{}, max1:0, max2:0, counts:{} }; continue; }
                    const counts = {};
                    for(const plateCode in this.stocks_plate[ban]){
                        const list = this.stocks_plate[ban][plateCode] || [];
                        for(const it of list){
                            const code = String(it['stock_code']||'');
                            if(!code) continue;
                            counts[code] = (counts[code]||0)+1;
                        }
                    }
                    const vals = Object.values(counts).filter(v=>v>0).sort((a,b)=>b-a);
                    const max1 = vals.length>0 ? vals[0] : 0;
                    const max2 = vals.length>1 ? vals[1] : 0;
                    const tops1 = {};
                    const tops2 = {};
                    if(max1>=3){ for(const c in counts){ if(counts[c]===max1) tops1[c]=true; } }
                    if(max2>=3){ for(const c in counts){ if(counts[c]===max2) tops2[c]=true; } }
                    result[ban] = { tops1, tops2, max1, max2, counts };
                }
                this.topStocksByBan = result;
            },
            isTopStock(ban, code){
                if(Number(ban)===0) return false;
                const info = this.topStocksByBan && this.topStocksByBan[ban];
                if(!info || !info.tops1) return false;
                const k = String(code||'');
                const cnt = (info.counts && info.counts[k]) || 0;
                if(cnt<3) return false;
                return !!info.tops1[k];
            },
            isSecondStock(ban, code){
                if(Number(ban)===0) return false;
                const info = this.topStocksByBan && this.topStocksByBan[ban];
                if(!info || !info.tops2) return false;
                const k = String(code||'');
                const cnt = (info.counts && info.counts[k]) || 0;
                if(cnt<3) return false;
                return !!info.tops2[k];
            },
            update_info(date1) {
                if (!date1) return;
                const curReqId = ++this.reqId;
                const curReqDate = date1;
                request_zzquant({
                    url: 'v3/open/review/uplimit/hot?date1=' + date1 + '&limit=' + this.show_top_n,
                }).then(res => {
                    if (curReqId !== this.reqId || curReqDate !== this.date1) return;
                    if(this.status_market==1){
                        let data = res && res.data && res.data.data;
                        if(data && data['stocks'] && data['stocks'].length > 0) {
                            request_zzquant({ url: '/v3/open/market/real?symbols='+data['stocks'] }).then(res2 => {
                                if (curReqId !== this.reqId || curReqDate !== this.date1) return;
                                this.update_table_info(res,res2);
                            }).catch(() => {
                                if (curReqId !== this.reqId || curReqDate !== this.date1) return;
                                this.update_table_info(res);
                            })
                        } else { this.update_table_info(res); }
                    }else{ this.update_table_info(res) }
                }).catch(() => {
                    if (curReqId !== this.reqId || curReqDate !== this.date1) return;
                    this.plates = [];
                    this.bans = [];
                    this.stocks_plate = {};
                    this.ban_info = {};
                })
            },
            openPlateModal(plate){
                this.selectedPlateCode = String(plate && plate.code || '')
                this.selectedPlateName = String(plate && plate.name || '')
                if(!this.selectedPlateCode) return
                this.showPlateModal = true
            },
            closePlateModal(){ this.showPlateModal=false },
            onCancelPrompt(){
                this.showLoginPrompt = false
                this.show_min_chart_ban1 = 0
                localStorage.setItem('uplimit_show_min_chart_ban1', 0)
                this.checkbox_ban1_key++
            },
            onPromptHidden(){
                this.show_min_chart_ban1 = 0
                localStorage.setItem('uplimit_show_min_chart_ban1', 0)
                this.checkbox_ban1_key++
            }
        },
    }
</script>

<style scoped>
.uplimit-step-view {
    overflow-x: hidden;
    padding-bottom: 20px;
}

.control-item {
    margin: 4px;
    display: flex;
    align-items: center;
}

.ladder-scroll-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: var(--bg-main);
}

.ladder-grid {
    display: flex;
    flex-direction: column;
}

.ladder-header-col {
    width: 80px;
    min-width: 80px;
    flex-shrink: 0;
    padding: 4px 2px;
    font-size: 13px;
    font-weight: bold;
}

.ladder-content-cell {
    padding: 0 !important;
    min-width: 100px;
}

.ban-row {
    display: flex;
    align-items: baseline;
    justify-content: center;
    width: 100%;
}

.ban-number {
    font-size: 14px;
    color: #e33e33;
    font-weight: bold;
}

.small-count {
    font-size: 11px;
    color: #666;
    background: rgba(0,0,0,0.05);
    padding: 0 4px;
    border-radius: 3px;
    font-weight: normal;
}

body.theme-dark .small-count {
    color: #aaa;
    background: rgba(255,255,255,0.1);
}

.plate-name-badge {
    cursor: pointer;
    font-weight: bold;
    font-size: 13px;
    color: var(--text-main);
    padding: 0 2px;
}

.plate-name-badge:hover {
    color: #007bff;
    text-decoration: underline;
}

.badge-score {
    display: inline-block;
    font-size: 10px;
    color: #007bff;
    border: 1px solid rgba(0, 123, 255, 0.5);
    padding: 0 4px;
    border-radius: 3px;
    line-height: 1.2;
}

.badge-success-outline {
    background: transparent;
    color: #28a745;
    border: 1px solid rgba(40, 167, 69, 0.5);
    font-size: 10px;
    padding: 0 4px;
    border-radius: 3px;
    margin-top: 2px;
}

.stock_item_block {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.4;
    color: var(--text-main);
    background-color: var(--bg-card);
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.mini-chart-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    background: var(--bg-muted);
}

.mini-chart-loading span {
    color: #999;
    font-size: 10px;
}

.top-stock-highlight {
    background-color: rgba(255, 193, 7, 0.1);
    border: 1px solid rgba(255, 193, 7, 0.3);
}

.second-stock-highlight {
    background-color: rgba(0, 123, 255, 0.1);
    border: 1px solid rgba(0, 123, 255, 0.3);
}

body.theme-dark .ladder-scroll-wrapper {
    border-color: #334155;
}

body.theme-dark .plate-name-badge {
    color: #f1f5f9;
}

body.theme-dark .badge-count {
    color: #94a3b8;
    border-color: #334155;
}

@media (max-width: 768px) {
    .ladder-header-col {
        width: 65px;
        min-width: 65px;
        font-size: 12px;
    }
    .ban-number {
        font-size: 13px;
    }
    .ladder-content-cell {
        min-width: 90px;
    }
}
</style>
